//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PropertyType } from '@devicepilot/manifest-types';
import { Operation, ops } from './helpers';

export default {
  name: 'VisualEditorRow',
  props: {
    value: { required: true, type: Object },
    disableTimeFilters: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: true },
    hideCalculatedProperties: { type: Boolean, default: false },
  },
  data() {
    return {
      internalValue: { left: null, op: null, right: null },
      operations: [],
      rowType: 'value',
      showTypeButtons: false,
      rowTypes: [
        { value: 'value', label: 'Property', icon: 'telemetry' },
        { value: 'time', label: 'Time', icon: 'time' },
      ],
      enumerations: [],
    };
  },
  computed: {
    rightType() {
      let type = Operation.NO_RIGHT;
      const { op, left } = this.internalValue;
      Object.keys(ops).forEach((k) => {
        if (ops[k].value === op) {
          type = ops[k].type;
        }
      });
      if (type === Operation.COMPARISON && left?.type === PropertyType.Boolean) {
        type = Operation.BOOLEAN;
      }

      return type;
    },
    allowedProperties() {
      if (this.disableTimeFilters) {
        return ['properties'];
      }
      return ['properties', 'timestamps'];
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = this.updateFromInput(value);
        this.changeLeft();
      },
    },
  },
  methods: {
    updateTime() {
      this.internalValue.right = this.calculatedTime;
      this.change();
    },
    updateFromInput(val) {
      const value = val;

      if (value.left && value.left) {
        const { enumerations } = this;
        if (enumerations.length) {
          value.right = enumerations
            .filter(({ v }) => v === value.right || v === `${value.right}`)[0].value;
        }
      }
      return value;
    },
    changeLeft() {
      const { left } = this.internalValue;
      if (!left) {
        this.operations = [ops.is, ops.isNot];
        return;
      }

      this.rowType = 'value';

      if (left.enumerations) {
        this.enumerations = left.enumerations;
      } else {
        this.enumerations = [];
      }

      const dataType = left.type;
      let options = [
        ops.is, ops.isNot,
      ];
      if (dataType === PropertyType.Number) {
        options = options.concat([
          ops.fewerThan, ops.fewerThanOrEqualTo, ops.greaterThan, ops.greatThanOrEqualTo,
        ]);
      } else if (dataType === PropertyType.String) {
        options = options.concat([
          ops.contains, ops.doesNotContain, ops.startsWith, ops.doesNotStartWith, ops.endsWith,
          ops.doesNotEndWith, ops.regex,
        ]);
      }

      // Add the null check options
      options = options.concat([ops.separator, ops.hasAnyValue, ops.hasNoValue]);

      const { op } = this.value;
      let found = false;
      if (op) {
        options.forEach((opt) => {
          if (opt.value === op) {
            found = true;
          }
        });
      }

      // Null the value if the op no longer exists
      if (!found) {
        this.internalValue.op = null;
      }

      // We first clear the operations and then add the correct ones as this helps
      this.operations = [];
      this.$nextTick(() => {
        this.operations = options;
        this.changeOp();
      });
    },
    changeOp() {
      this.change();
    },
    change() {
      this.$emit('change', this.internalValue);
      this.$emit('input', this.internalValue);
    },
    deleteRow() {
      this.$emit('delete');
    },
    propertyFilterFn(prop) {
      return !this.hideCalculatedProperties || !prop.isCalculated;
    },
  },
};
